/**
 * StoreForm Component - Created by david on 09/04/18.
 */
import * as React from 'react'
import Input from 'antd/lib/input'
import message from 'antd/lib/message'
import DatePicker from 'antd/lib/date-picker'
import Modal from 'antd/lib/modal'
import moment, { Moment } from 'moment'
import {
  Container,
  Label,
  Column,
  Error,
  Required,
  inputStyle,
  TeamStoreTypeLabel,
  RightLabels,
  Fields,
  Question,
  ModalTitle,
  InfoBody,
  buttonStyle,
  ColumnName,
  DirectShipLogo,
  BulkShipTag,
  BulkShipTagIcon,
  BulkShipContainer,
  BulkShipTagDescription,
  BulkShipTermsLink,
  ViewBulkShipButton,
  TermsDiv,
  EnabledLabel,
  StyledTooltip
} from './styledComponents'
import messages from './messages'
import { bulkShipIcon, DAY_SATURDAY, DAY_SUNDAY } from '../../constants'
import onDemandBanner from '../../assets/OnDemand.png'
import scheduledBanner from '../../assets/BatchOrder-Logo.png'
import directShipLogo from '../../assets/directship_dark.png'
import BulkAddressCard from '../BulkAddressCard'

const { info } = Modal

interface Props {
  hasError?: boolean
  name: string
  startDate?: Moment
  initialStartDate?: Moment
  endDate?: Moment
  onDemand?: boolean
  validateHoliday: any
  cutoffDays: number
  storeId: string
  datesEdited: boolean
  showDirectShip: boolean
  isReseller: boolean
  isFixedPrice: boolean
  bulkShipOption: boolean
  isMandatory: boolean
  bulkShipFirstName: string
  bulkShipLastName: string
  bulkShipStreet: string
  bulkShipApartment: string
  bulkShipCountry: string
  bulkShipStateProvince: string
  bulkShipCity: string
  bulkShipZipCode: string
  bulkShipPhone: string
  toggleLearnMoreModal: () => void
  onUpdateName: (name: string) => void
  onSelectStartDate: (
    dateMoment: Moment,
    date: string,
    datesEdited: boolean
  ) => void
  onSelectEndDate: (
    dateMoment: Moment | null,
    date: string,
    datesEdited: boolean
  ) => void
  formatMessage: (messageDescriptor: any, values?: any) => string
}
const INPUT_MAX_LENGTH = 30
const StoreForm = ({
  hasError = false,
  onUpdateName,
  onSelectStartDate,
  onSelectEndDate,
  name,
  initialStartDate,
  startDate,
  isReseller,
  endDate,
  onDemand,
  showDirectShip,
  formatMessage,
  cutoffDays,
  storeId,
  datesEdited,
  bulkShipOption,
  isMandatory,
  bulkShipFirstName,
  bulkShipLastName,
  bulkShipStreet,
  bulkShipApartment,
  bulkShipCountry,
  bulkShipStateProvince,
  bulkShipCity,
  bulkShipZipCode,
  bulkShipPhone,
  toggleLearnMoreModal
}: Props) => {
  const handleUpdateName = (evnt: React.ChangeEvent<HTMLInputElement>) => {
    const {
      target: { value }
    } = evnt

    if (value.length > INPUT_MAX_LENGTH) {
      return
    }

    onUpdateName(value)
  }

  const disabledStartDate = (current: any) => {
    if (!current) {
      return false
    }

    const date = moment()
    date.hour(0)
    date.minute(0)
    date.second(0)

    date.add('1', 'days')
    const isBeforeOfCurrentDay = current.valueOf() < date.valueOf()

    let momentStartDate
    if (storeId && !datesEdited) {
      momentStartDate = moment(initialStartDate || date)
      momentStartDate.add('21', 'days')
    } else {
      date.add('21', 'days')
      momentStartDate = date.valueOf()
    }
    const isGreaterThanFourteenDays = current.valueOf() > momentStartDate

    return isBeforeOfCurrentDay || isGreaterThanFourteenDays
  }

  const disabledEndDate = (current: any) => {
    if (!current) {
      return false
    }
    let isLessThanDeliveryDate = false
    let isGreaterThanTwentyDays = false
    if (startDate) {
      const maxEndDate = startDate.clone()
      maxEndDate.add(cutoffDays, 'days')
      isLessThanDeliveryDate = current.valueOf() < maxEndDate.valueOf()
      maxEndDate.add(6, 'days')
      isGreaterThanTwentyDays = current.valueOf() > maxEndDate.valueOf()
    }

    const date = moment()
    date.hour(0)
    date.minute(0)
    date.second(0)
    // if (startDate && (
    //   (startDate.month() === 8 && startDate.date() >= 24 && startDate.date() <= 30) ||
    //   (startDate.month() === 9 && startDate.date() === 1)
    // )) {
    //   const enabledDates = current && current.month() === 9 && current.date() >= 17 && current.date() <= 23
    //   return !enabledDates || current.isoWeekday() === DAY_SATURDAY || current.isoWeekday() === DAY_SUNDAY
    // }
    const isWeekend = current.isoWeekday() === DAY_SATURDAY || current.isoWeekday() === DAY_SUNDAY
    const isBeforeOfCurrentDay = current.valueOf() < date.valueOf()
    date.add(15, 'days')
    return (
      isBeforeOfCurrentDay || isLessThanDeliveryDate || isGreaterThanTwentyDays || isWeekend
    )
  }

  const handleOnSelectStart = (date: Moment, dateString: string) => {
    onSelectStartDate(date, dateString, !!storeId)
  }

  const handleOnSelectEnd = async (date: Moment, dateString: string) => {
    if (date) {
      try {
        if (date && (date.weekday() === 0 || date.weekday() === 6)) {
          message.warning(formatMessage(messages.deliveryErrorLabel))
          onSelectEndDate(null, '', !!storeId)
          return
        }
      } catch (error) {
        message.error(formatMessage(messages.errorMsg))
      }
    }
    onSelectEndDate(date, dateString, !!storeId)
  }

  const openInfo = () => {
    info({
      title: <ModalTitle>{formatMessage(messages.aboutCutOff)}</ModalTitle>,
      icon: ' ',
      width: '454px',
      okText: formatMessage(messages.gotIt),
      okButtonProps: {
        style: buttonStyle
      },
      content: 
        <InfoBody
          dangerouslySetInnerHTML={{
            __html: formatMessage(messages.aboutCutOffInfo)
          }}
        />
    })
  }

  const openDeliveryInfo = () => {
    info({
      title: <ModalTitle>{formatMessage(messages.aboutDelivery)}</ModalTitle>,
      icon: ' ',
      okText: formatMessage(messages.gotIt),
      okButtonProps: {
        style: buttonStyle
      },
      content: 
        <InfoBody>
          {formatMessage(messages.aboutDeliveryInfo, { startDate: cutoffDays, endDate: cutoffDays + 5 })}
        </InfoBody>
    })
  }

  return (
    <Container>
      <RightLabels>
        {showDirectShip && <DirectShipLogo src={directShipLogo} />}
        <TeamStoreTypeLabel
          src={onDemand ? onDemandBanner : scheduledBanner}
        />
      </RightLabels>
      <Fields secondary={bulkShipOption && !onDemand}>
        <ColumnName secondary={bulkShipOption && !onDemand}>
          <Label>
            {formatMessage(messages[isReseller ? 'storeName' : 'teamStoreName'])} <Required>*</Required>
          </Label>
          <Input
            value={name}
            placeholder="Store Name"
            size="large"
            onChange={handleUpdateName}
          />
          {hasError && !name && (
            <Error>{formatMessage(messages.requiredFieldLabel)}</Error>
          )}
        </ColumnName>
        {!onDemand && (
          <React.Fragment>
            <Column>
              <Label>
                {formatMessage(messages.orderCutOffLabel)}
                <Required>*</Required>
                <Question onClick={openInfo} type="question-circle" />
              </Label>
              <DatePicker
                value={startDate}
                disabledDate={disabledStartDate}
                onChange={handleOnSelectStart}
                format="YYYY-MM-DD" // TODO: Change format
                size="large"
                style={inputStyle}
                disabled={datesEdited}
              />
              {hasError && !startDate && (
                <Error>{formatMessage(messages.requiredFieldLabel)}</Error>
              )}
            </Column>
            <Column>
              <Label>
                {formatMessage(messages.desiredDeliveryLabel)}
                <Required>*</Required>
                <Question onClick={openDeliveryInfo} type="question-circle" />
              </Label>
              <DatePicker
                value={endDate}
                disabledDate={disabledEndDate}
                onChange={handleOnSelectEnd}
                disabled={datesEdited || !startDate}
                format="YYYY-MM-DD" // TODO: Change format
                size="large"
                style={inputStyle}
              />
              {hasError && !endDate && (
                <Error>{formatMessage(messages.requiredFieldLabel)}</Error>
              )}
            </Column>
          </React.Fragment>
        )}
        {bulkShipOption && !onDemand &&
          <BulkShipTag>
            <BulkShipTagIcon src={bulkShipIcon} />
            <BulkShipContainer>
              <BulkShipTagDescription>
                {formatMessage(messages.bulkShipping, {
                  bulkShipType: isMandatory ? formatMessage(messages.mandatory) : formatMessage(messages.optional)
                })}
              </BulkShipTagDescription>
              <TermsDiv>
                <EnabledLabel>Enabled</EnabledLabel>
                <BulkShipTermsLink onClick={toggleLearnMoreModal}>
                  {formatMessage(messages.bulkShipTerms)}
                </BulkShipTermsLink>
              </TermsDiv>
            </BulkShipContainer>
          </BulkShipTag>
        }
        {bulkShipFirstName && !onDemand &&
          <StyledTooltip
            overlayClassName="roundedTooltip"
            placement="left"
            trigger="click"
            overlayStyle={{
              boxShadow: '1px 1px 4px -1px #a8a8a8', 
              borderRadius: '7px', 
              border: '1px solid #ecd3bd' 
            }}
            content={
              <BulkAddressCard
                {...{
                  bulkShipFirstName,
                  bulkShipLastName,
                  bulkShipStreet,
                  bulkShipApartment,
                  bulkShipCountry,
                  bulkShipStateProvince,
                  bulkShipCity,
                  bulkShipZipCode,
                  bulkShipPhone
                }}
                fromEdit={true}
              />
            }
          >
            <ViewBulkShipButton>Show Bulk Ship Address</ViewBulkShipButton>
          </StyledTooltip>
        }
      </Fields>
    </Container>
  )
}

export default StoreForm



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/StoreForm/index.tsx